<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>公司汽车审车登记使用说明:<br>
					<span>1、单号构成规则:201201+SC+4位顺序号。系统生成,添加无效</span><br>
					<span>2、由录入人员录入审车费用，确定经办人。当提交后，由经办人申请相关费用报销。</span><br>
					<span>3、查询关键字:汽车编号、车牌、审车日期。</span><br>
				</h5>
			</div>
		</div>

		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">

		</pre-base>

	</div>
</template>

<script>
	import api from '@/utils/type.js';
	import {
		Method_EasySelect
	} from '@/utils/loadhttpdata.js';
	export default {
		components: {
			"pre-base": () => import("../auto/old_view_v1_new.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: ''
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {
				// //事故附件操作老方法 carSC
				this.init_data = '';
				this.init_data = JSON.stringify({
					"title": '审车',
					"control": "carCheck",
					"isTwo": "1",
					"isTwoDetail": "1",
					"action_flag": "",
					"isFileMain": "1",
					"step": "0",
					"sel_action": 'exp_car_carCheck',
					"upd_action": 'exp15_car_carCheck',
					"detail_part": "1",
					"d_sel_action": 'exp_car_carFile',
					"d_upd_action": 'car_carFile',
					"file_action": 'filemore',
					"p1": 'car',
					"p2": 'sc',
					"p3": '',
					"parm_sel": [{
							"name": "单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"sel": "1"
						},
						{
							"name": "车牌",
							"val": "",
							"key": "car_no",
							"type": "selectnew",
							"class": "long1",
							"sel_action": "data_exp_car",
							"sel_val": {},
							"sel_name": "",
							"sel": "2",
							"sel_more": "A_to",
						},
						{
							"name": "车挂别名",
							"val": "",
							"key": "cp_no",
							"type": "selectnew",
							"class": "long1",
							"sel_action": "_base_car_bm",
							"sel_name": "",
							"sel_more": "A",
							"sel": "6"
						},
						{
							"name": "状态",
							"val": "",
							"key": "flag",
							"type": "selectnew",
							"class": "long1",
							"sel_action": "data_flag",
							"sel_name": "",
							"sel": "3"
						},
						{
							"name": "开始修改时间",
							"val": "",
							"key": "s_sys_date",
							"type": "date",
							"class": "long1",
							"sel": "4"
						},
						{
							"name": "截止修改时间",
							"val": "",
							"key": "e_sys_date",
							"type": "date",
							"class": "long1",
							"sel": "5"
						}
					],
					"parm": [{
							"name": "单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long2",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "车牌号码",
							"val": "",
							"key": "c_no",
							"type": "selectnew",
							"class": "long1",
							"sel_action": "data_exp_car",
							"sel_name": "",
							"sel_more": "A_to",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "车挂别名",
							"val": "",
							"key": "cp_no",
							"type": "selectnew",
							"class": "long1",
							"sel_action": "_base_car_bm",
							"sel_name": "",
							"sel_more": "A",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long3",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "经办人",
							"val": "",
							"key": "u_name",
							"type": "selectnew",
							"class": "long1",
							"sel_action": "data_alluser",
							"sel_name": "",
							"p": "1",
							"x": "2"
						}
					],
					"parm_th": [{
							"name": "序号"
						}, {
							"name": "单号"
						},
						{
							"name": "车牌号码"
						},
						{
							"name": "车挂别名"
						},
						{
							"name": "总费用"
						},
						{
							"name": "备注",
							"class": "long2"
						},
						{
							"name": "附件"
						},
						{
							"name": "明细",
							"class": "long2"
						},
						{
							"name": "经办人",
							"class": "short0"
						},
						{
							"name": "状态",
							"class": "short0"
						},
						{
							"name": "修改人",
							"class": "short0"
						},
						{
							"name": "路径1"
						},
						{
							"name": "路径2"
						},
						{
							"name": "修改时间",
							"class": "long2"
						}
					],
					"d_parm": [{
							"name": "单号",
							"val": '',
							"key": "sheet_no",
							"type": "none",
							"p": "1",
							"r": "1"
						},
						{
							"name": "审核公司",
							"val": '',
							"key": "f_note",
							"type": "none",
							"class": "long1",
							"p": "1",
							"r": "1"
						},
						{
							"name": "费用名称",
							"val": "",
							"key": "u_name",
							"type": "selectnew",
							"class": "long1",
							"sel_action": "_base_out_classok_sc",
							"sel_name": "",
							"p": "1",
							"r": "0"
						},
						{
							"name": "审车日期",
							"val": "",
							"key": "f_date",
							"type": "date",
							"class": "long1",
							"p": "1",
							"r": "0"
						},
						{
							"name": "费用金额",
							"val": "",
							"key": "amount",
							"type": "number",
							"class": "long1",
							"p": "1",
							"r": "0"
						}
					],
					"d_name": [{
							"name": "ID"
						},
						{
							"name": "序号"
						},
						{
							"name": "单号"
						},
						{
							"name": "费用名称"
						},
						{
							"name": "费用金额"
						},
						{
							"name": "审车日期"
						},
						{
							"name": "有无附件"
						},
						{
							"name": "修改人"
						},
						{
							"name": "修改时间"
						},
						{
							"name": "存储地址"
						},
						{
							"name": "访问地址"
						}
					]

				});
			},
			refresh_data: function(type) {
				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data(type);
				});
			},
			refresh_father: function(type, val, parm) {
				// console.log('type=' + type + ' val=' + val);
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						this.refresh_data();
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			},
			/*****************************************************/
			/*****************************************************/
			// loadClass: function(action, p1, p2, p3) {
			//   let that = this;
			//   return new Promise((resolve, reject) => {
			//     // console.log(menuvalue);
			//     that.$post(
			//       api.http_method, Method_EasySelect(action, p1, p2, p3)
			//     ).then(res => {
			//       res = JSON.parse(res);
			//       // console.log(res.data);
			//       resolve(res.data)
			//     });

			//   });
			// }


		}
	};
</script>
<style scoped>
	/* 设置 倒数 第二、第三列 隐藏 */
	.path_none>td:nth-last-child(3),
	.path_none>td:nth-last-child(2) {
		display: none;
	}
</style>